const mEditionMapContentsTreeNodeStudentContent = {
  mEditionMapContentsTreeNodeStudentContent: {
    alerts: {
      updateInscripcionNodoEstado: {
        error: 'Un error ha ocurrido. Vuelve a intentarlo en un momento.',
        activationSuccess: 'El contenido fue activado exitosamente.',
        deactivationSuccess: 'El contenido fue desactivado exitosamente.'
      }
    },

    tooltips: {
      activeFalse: 'Activar',
      activeTrue: 'Desactivar',
      seenFalse: 'No Visto',
      seenTrue: 'Visto'
    }
  }
}

export default mEditionMapContentsTreeNodeStudentContent
